import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { modalsButtonStyles } from '../../../collums-constants/styles/stylesheets/buttonsStyles';

const styles = {
    dialogClass: {
        '& .MuiDialog-paper': {
            paddingBottom: 24
        }
    },
    content: {
        '& .MuiDialogContent-root': {
            paddingTop: 8,
            paddingBottom: 18
        }
    },
    closeButton: {
        position: 'absolute',
        right: 6,
        top: 6,
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: 20
    },
    dialogTitle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& p': {
            fontSize: 16,
            fontWeight: 500
        }
    }
};

const DialogFullHeight = withStyles(() => ({
    paper: {
        height: '100%'
    }
}))(MuiDialog);

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fullWidth: true,
            maxWidth: 'xl'
        };
    }

    renderActions() {
        const { classes } = this.props;
        const buttons = [];

        if (this.props.customButtons) {
            return this.props.customButtons;
        }

        if (this.props.onCancel && !this.props.hideCancel) {
            buttons.push(
                <Button className={classes.cancelButton} key="cancel" onClick={this.props.onCancel}>
                    {this.props.cancelLabel || 'Cancel'}
                </Button>
            );
        }

        if (this.props.actions) {
            this.props.actions.forEach(action => {
                buttons.push(
                    <Button className={classes.baseButton} key="confirm" onClick={action.action}>
                        {action.label}
                    </Button>
                );
            });
        }

        if (this.props.extraButtons) {
            buttons.push(...this.props.extraButtons);
        }

        if (this.props.onConfirm) {
            buttons.push(
                <Button
                    className={classes.confirmButton}
                    disabled={this.props.disableConfirmButton || false}
                    key="confirm"
                    onClick={this.props.onConfirm}
                >
                    {this.props.confirmLabel || 'Confirm'}
                </Button>
            );
        }
        return buttons;
    }

    render() {
        const { classes } = this.props;
        const Dialog = this.props.fullHeight ? DialogFullHeight : MuiDialog;
        return (
            <Dialog
                fullWidth
                maxWidth={this.props.size || 'xl'}
                id="modal"
                open={this.props.isOpen}
                onClose={this.props.onCancel}
                aria-labelledby={this.props.id}
                classes={{ root: classes.dialogClass }}
                disableBackdropClick={this.props.disableBackdropClick}
            >
                <DialogTitle className={classes.dialogTitle} id={this.props.id}>
                    <Typography style={{ ...this.props.titleStyle }}>{this.props.title}</Typography>
                    {this.props.hideCloseIcon ? (
                        ''
                    ) : (
                        <IconButton className={classes.closeButton} onClick={this.props.onClose}>
                            <Close />
                        </IconButton>
                    )}
                </DialogTitle>
                <div className={classes.content}>
                    <DialogContent>{this.props.children}</DialogContent>
                </div>
                {!this.props.hideActions && <DialogActions>{this.renderActions()}</DialogActions>}
            </Dialog>
        );
    }
}

Modal.propTypes = {
    classes: PropTypes.object,
    id: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    titleStyle: PropTypes.object,
    size: PropTypes.string,
    cancelLabel: PropTypes.string,
    confirmLabel: PropTypes.string,
    disableConfirmButton: PropTypes.bool,
    fullHeight: PropTypes.bool,
    actions: PropTypes.array,
    extraButtons: PropTypes.array,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    onClose: PropTypes.func,
    customButtons: PropTypes.array,
    children: PropTypes.node.isRequired,
    hideCloseIcon: PropTypes.bool,
    hideCancel: PropTypes.bool,
    hideActions: PropTypes.bool,
    disableBackdropClick: PropTypes.bool
};

export default withStyles(theme => ({ ...styles, ...modalsButtonStyles(theme) }))(Modal);
